"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortArrows = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
var ArrowDropUp_1 = __importDefault(require("@material-ui/icons/ArrowDropUp"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        dropdown: {
            display: "inline-grid",
        },
        sortButton: {
            "&:focus": {
                color: theme.palette.text.secondary,
            },
        },
    });
});
var SortArrows = function (props) {
    var classes = useStyles();
    var doubleArrows = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ArrowDropUp_1.default, { viewBox: "1 -9 24 24", color: "disabled" }),
        react_1.default.createElement(ArrowDropDown_1.default, { viewBox: "1 9 24 24", color: "disabled" })));
    return (react_1.default.createElement("div", __assign({}, props.innerProps, { className: classes.dropdown }), !props.active ? (doubleArrows) : props.direction === "asc" ? (react_1.default.createElement(ArrowDropUp_1.default, null)) : (react_1.default.createElement(ArrowDropDown_1.default, null))));
};
exports.SortArrows = SortArrows;
var SortLabel = function (_a) {
    var label = _a.label, active = _a.active, direction = _a.direction, ButtonProps = _a.ButtonProps;
    var classes = useStyles();
    var _b = (0, react_1.useState)(false), hovered = _b[0], setHovered = _b[1];
    return (react_1.default.createElement(core_1.ButtonBase, __assign({ className: classes.sortButton, style: hovered ? { opacity: ".7" } : undefined, onMouseOver: function () { return setHovered(true); }, onMouseOut: function () { return setHovered(false); } }, ButtonProps),
        react_1.default.createElement("b", null, label),
        react_1.default.createElement("span", { style: { position: "relative", paddingRight: "2rem" } },
            react_1.default.createElement("div", { style: {
                    position: "absolute",
                    top: "50%",
                    left: "1rem",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                } },
                react_1.default.createElement(exports.SortArrows, { active: active || hovered, direction: hovered && !active ? "asc" : direction })))));
};
exports.default = SortLabel;
//# sourceMappingURL=SortLabel.js.map